<template>
 <div class="admin-list bg-white">
   <div class="container-fluid" v-if="allAdmin">
     <sidebar />
      <div v-if="deleteMsg">
          {{statusAlert(true)}}
      </div>
     <div class="col-md-9 col-lg-10 ml-md-auto py-4" v-if="permission">
       <div class="header d-flex justify-content-between w-100 align-items-center py-3 mb-3 border-bottom border-dark">
         <h2 class="m-0">管理者一覧</h2>
         <div v-if="permission.data">
          <router-link class="text-white" to="/administrator/admin-register"><b-button class="px-4 py-2" variant="primary" v-show="permissionControll[0].permission === 'all'">新規追加</b-button></router-link>
         </div>
       </div>
       <div v-if="allAdmin.listAdmin">
       <div v-if="permission.data">
        <div class="responsive-table">
         <b-table id="my-table"
            head-variant="p-3 mb-2 bg-light text-dark" bordered
            :items="filteredAdmin"
            :per-page="perPage"
            :current-page="currentPage"
            :fields="fields"
            select-mode="single"
            selectable
            @row-selected="onRowSelected"
            hover
          >
            <template #cell(fullname)="row">
                <router-link class="text-dark" :to="'/administrator/edit-admin-super/' + row.item.id"> {{ row.value }}</router-link>
            </template>
          </b-table>
        </div>
        <div>
        <div class="m-4" v-if="allAdmin.listAdmin">
          <b-pagination class="position-relative" align="center" size="lg"
            v-model="currentPage"
            :total-rows="filteredAdmin.length"
            :per-page="perPage"
            :limit="4"
            :show-step-links="true"
            aria-controls
            first-number
            last-number
            v-show="pages"
          >
          <template #prev-text><span><b-icon icon="chevron-left" scale="1.5"></b-icon></span></template>
          <template #next-text><span><b-icon icon="chevron-right" scale="1.5"></b-icon></span></template>
          </b-pagination>
        </div>
        </div>
       </div>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import sidebar from '@/components/_sidebar/sidebar'
import { mapState, mapActions } from 'vuex'
import { administratorValues } from '../../assets/data/values'

export default {
  data () {
    return {
      fields: [
        {
          key: 'fullname',
          label: '氏名',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'role.name',
          label: '権限',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return administratorValues.authorityType.filter(t => t.value === value).map(t => t.text)[0]
          }
        },
        {
          key: 'area_responsibility',
          label: '担当エリア',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return administratorValues.areaType.filter(t => t.value === value).map(t => t.text)[0]
          }
        },
        {
          key: 'created_at',
          label: '登録日',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            if (value) {
              return value.substring(0, 10).replace(/-/g, '/')
            }
            return this.$i18n.t(value)
          }
        }
      ],
      rows: 8,
      perPage: 30,
      allPage: null,
      currentPage: 1,
      paginate: false
    }
  },
  created () {
    this.getAllAdmin()
    this.getPermission()
  },
  computed: {
    ...mapState('adminAccount', ['adminData', 'permission', 'allAdmin', 'deleteMsg']),
    pages: function () {
      if (this.filteredAdmin.length <= 30) {
        return false
      } else {
        return true
      }
    },
    permissionControll: function () {
      return this.permission.data
        .filter(this.filterBySubject)
    },
    filteredAdmin: function () {
      return this.allAdmin.listAdmin
        .filter(this.filterByPermission)
    }
  },
  methods: {
    ...mapActions('adminAccount', ['getAllAdmin', 'getPermission']),
    filterBySubject: function (data) {
      return (data.subject === 'administrator_accounts')
    },
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.deleteMsg,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    },
    buttonState: function () {
      if (this.selected.length === 0) {
        return true
      } else {
        return false
      }
    },
    onRowSelected (items) {
      this.$router.push({ name: 'Edit Administration (Super Authority)', params: { id: items[0].id } })
    },
    filterByPermission: function (admin) {
      if (this.permission.data[0].permission !== 'all') {
        return (admin.role.id === this.permission.data[0].administrator_role_id)
      } else {
        return true
      }
    }
  },
  components: {
    sidebar
  }
}
</script>
